export default {
  setProject(state, payload) {
    return (state.project = payload);
  },
  setProjects(state, payload) {
    return (state.projects = payload);
  },
  setRegion(state, payload) {
    return (state.region = payload);
  },
  setRegions(state, payload) {
    return (state.regions = payload);
  },
  setLoading(state, payload) {
    return (state.loading = payload);
  },
  setDashboard(state, payload) {
    return (state.dashboard = payload);
  },
  setDashboards(state, payload) {
    return (state.dashboards = payload);
  },
  setDashboardActiveTab(state, payload) {
    return (state.dashboardActiveTab = payload);
  },
  setDashboardActiveMenu(state, payload) {
    return (state.dashboardActiveMenu = payload);
  },
  setWidgetRefresh(state, payload) {
    return (state.widgetRefresh = payload);
  },
  setProductSubTypesY(state, payload) {
    return (state.productSubTypesY = payload);
  },
  setProductSubTypesN(state, payload) {
    return (state.productSubTypesN = payload);
  },
  setAgentProductTypes(state, payload) {
    return (state.agentProductTypes = payload);
  },
  setParameters(state, payload) {
    return (state.params[Object.keys(payload)[0]] = Object.values(payload)[0]);
  },
  setInconProductType(state, payload) {
    return (state.iconProductType = payload);
  },
  setProjectSelected: (state, payload) => {
    if (!payload) return (state.isMatchCurrentProject = true);
    return (state.isMatchCurrentProject = state.project.key == payload.projectId);
  }
};
